import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { IMenuSpot } from '@ncg/data';
import { ButtonModule } from '../../../button/button.module';
import { UtilsModule } from '../../../utils/utils.module';
import { LazyContentData, LazyContentGenericComponent } from '../../models/lazy-content.models';

@Component({
    selector: 'ncg-menu-spot',
    template: `
        <aside class="menu-spot mega-menu__item--animate">
            <div class="menu-spot__container" *ngIf="data">
                <div class="menu-spot__img-wrapper" *ngIf="data.menuSpotImage && data.menuSpotImage.url">
                    <img
                        class="menu-spot__img"
                        [src]="data.menuSpotImage | imageUrl: { width: 320, height: 200, mode: 'crop' }"
                        [srcset]="data.menuSpotImage | imageUrl: { width: 320, height: 200, mode: 'crop' } : 2"
                        [alt]="data.menuSpotImage.altText || 'car guide image'"
                        loading="lazy"
                        ncgImageLoad />
                </div>
                <div class="menu-spot__content">
                    <h3 class="menu-spot__header">{{ data.menuSpotHeading }}</h3>
                    <div class="menu-spot__description">{{ data.menuSpotDescription }}</div>
                </div>
                <div class="menu-spot__btn-wrapper" *ngIf="data.menuSpotLink">
                    <ncg-button role="menuitem" [link]="data.menuSpotLink" [title]="data.menuSpotLink.name" [isSecondary]="true"></ncg-button>
                </div>
            </div>
        </aside>
    `,
    styleUrls: ['./menu-spot.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MenuSpotComponent implements LazyContentGenericComponent<IMenuSpot> {
    @Input()
    public data?: LazyContentData<IMenuSpot>;
}

@NgModule({
    declarations: [MenuSpotComponent],
    imports: [CommonModule, UtilsModule, ButtonModule],
})
export class MenuSpotModule {}
